import { PropertyConverter } from 'angular2-jsonapi'
import { Estabelecimento } from '../estabelecimento/estabelecimento.model'

import { Agrupamento } from '../extrato/agrupamento.model'
import { Detalhe } from '../extrato/detalhe.model'
import { Transacao } from '../extrato/transacao.model'
import { EstabelecimentoConverter } from './estabelecimentos.converter'
import { OperadoraDeMaquinaConverter } from './operadora-de-maquina.converter'
import { TransacaoConverter } from './transacao.converter'

export class AgrupamentoConverter<T extends Transacao> implements PropertyConverter {
    constructor(private construtor: new () => T) {}

    static toModel<T extends Transacao>(
        construtor: new () => T,
        obj: any
    ): Agrupamento<T> {
        if (obj instanceof Agrupamento) {
            return obj
        }

        const model = new Agrupamento<T>()

        model.bandeira = obj.bandeira
        model.detalhes = obj.detalhes.map(detalheObj =>
            AgrupamentoConverter.DetalheToModel(construtor, detalheObj)
        )
        model.operadora = OperadoraDeMaquinaConverter.toModel(obj.operadora)
        model.transacao = TransacaoConverter.toModel(construtor, obj.transacao)
        model.estabelecimento = obj.estabelecimento && EstabelecimentoConverter.toModel(obj.estabelecimento)
        return model
    }

    static toJSON<T extends Transacao>(model: Agrupamento<T>) {
        const json = Object.assign({}, model)

        json.detalhes = model.detalhes.map(AgrupamentoConverter.DetalheToJSON)
        json.transacao = TransacaoConverter.toJSON(model.transacao)
        json.operadora = OperadoraDeMaquinaConverter.toJSON(model.operadora)
        json.estabelecimento = EstabelecimentoConverter.toJSON(model.estabelecimento)

        return json
    }

    static DetalheToModel<T extends Transacao>(
        construtor: new () => T,
        obj: any
    ): Detalhe<T> {
        if (obj instanceof Detalhe) {
            return obj
        }

        const model = new Detalhe<T>()

        model.transacao = TransacaoConverter.toModel(construtor, obj.transacao)
        model.agrupamentos = obj.agrupamentos.map(agrupamentoObj =>
            AgrupamentoConverter.toModel(construtor, agrupamentoObj)
        )

        return model
    }

    static DetalheToJSON<T extends Transacao>(model: Detalhe<T>) {
        const json = Object.assign({}, model)

        json.transacao = TransacaoConverter.toJSON(model.transacao)
        json.agrupamentos = model.agrupamentos.map(AgrupamentoConverter.toJSON)

        return json
    }

    mask(value: any) {
        return AgrupamentoConverter.toModel(this.construtor, value)
    }

    unmask(value: any) {
        return AgrupamentoConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/converters/agrupamento.converter.ts